import React, { FC } from 'react'

import { Content } from 'sdk/components'
import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'

import classes from './style.module.scss'

interface BottomHeroSectionProps {
  title: string | React.ReactNode
  description?: string
  buttonText?: string
  buttonHref?: string
  buttonOnClick?: () => void
}

export const BottomHeroSection: FC<BottomHeroSectionProps> = ({
  title,
  description,
  buttonText = 'Learn more',
  buttonHref,
  buttonOnClick,
}) => {
  const isExternalButtonHref = Boolean(buttonHref && /^(https?:\/\/|mailto:|tel:)/.test(buttonHref))
  let buttonAs: 'button' | 'link' | 'router-link' = 'button'

  if (buttonHref) {
    buttonAs = isExternalButtonHref ? 'link' : 'router-link'
  }

  return (
    <section className={classes.section}>
      <Content>
        <div className={classes.wrapper}>
          <div className={classes.texts}>
            <Text type={TextName.H1} className={classes.title}>
              {title}
            </Text>
            {description && (
              <Text type={TextName.Text} className={classes.description}>
                {description}
              </Text>
            )}
          </div>
          <Button
            as={buttonAs}
            href={isExternalButtonHref ? buttonHref : undefined}
            to={buttonHref && !isExternalButtonHref ? buttonHref : undefined}
            onClick={buttonHref ? undefined : buttonOnClick}
            target={isExternalButtonHref ? '_blank' : undefined}
          >
            {buttonText}
          </Button>
        </div>
      </Content>
    </section>
  )
}
